@if (empresa() !== null) {
  <!-- Sección de Información Básica -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
    <!-- Tarjeta RUC -->
    <div class="bg-white rounded-lg shadow-md p-6 border-l-4 border-blue-500">
      <label class="block text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2"
        >RUC</label
      >
      <p class="text-md font-bold text-slate-900">{{ empresa()!.ruc }}</p>
    </div>

    <!-- Tarjeta Nombre -->
    <div class="bg-white rounded-lg shadow-md p-6 border-l-4 border-green-500">
      <label class="block text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2"
        >Empresa</label
      >
      <p class="text-md font-bold text-slate-900">{{ empresa()!.nombre }}</p>
    </div>

    <!-- Tarjeta Licencia -->
    <div class="bg-white rounded-lg shadow-md p-6 border-l-4 border-purple-500">
      <label class="block text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2"
        >Licencia Vence</label
      >
      <p class="text-md font-bold text-slate-900">
        {{ empresa()!.licencia_vence | date: 'shortDate' }}
      </p>
    </div>
  </div>

  <!-- Sección de Datos Editables -->
  <form class="bg-white rounded-lg shadow-md p-8 mb-8" (submit)="guardarEmpresa()">
    <h2 class="text-2xl font-bold text-slate-900 mb-6 pb-4 border-b border-slate-200">
      Información de Contacto
    </h2>

    <div class="mb-6">
      <app-cargar-foto />
    </div>

    <div class="grid grid-cols-2 md:grid-cols-3 gap-6 mb-6">
      <!-- Teléfono -->
      <div>
        <label class="block text-sm font-medium text-slate-700 mb-2">Teléfono</label>
        <app-input-mask
          mask="+51-999-999-999"
          [(value)]="numero_celular"
          placeholder="+51-999-999-999"
          styleClass="w-full"
        />
      </div>

      <!-- Email -->
      <div>
        <label class="block text-sm font-medium text-slate-700 mb-2">Email</label>
        <input
          type="email"
          class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          [formField]="$any(formulario_empresa.email)"
          placeholder="Ingresa el email"
          [class.p-invalid]="
            formulario_empresa.email().invalid() && formulario_empresa.email().touched()
          "
        />
        @if (formulario_empresa.email().invalid() && formulario_empresa.email().touched()) {
          <div class="text-xs text-red-500 mt-1">
            {{ formulario_empresa.email().errors() | formErrorMessage }}
          </div>
        }
      </div>

      <!-- Dirección -->
      <div>
        <label class="block text-sm font-medium text-slate-700 mb-2">Dirección</label>
        <input
          type="text"
          class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          [formField]="$any(formulario_empresa.direccion)"
          placeholder="Ingresa la dirección"
          [class.p-invalid]="
            formulario_empresa.direccion().invalid() && formulario_empresa.direccion().touched()
          "
        />
        @if (formulario_empresa.direccion().invalid() && formulario_empresa.direccion().touched()) {
          <div class="text-xs text-red-500 mt-1">
            {{ formulario_empresa.direccion().errors() | formErrorMessage }}
          </div>
        }
      </div>
    </div>

    <div class="flex justify-center gap-4">
      <button
        type="submit"
        class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
      >
        Guardar Cambios
      </button>
      <button
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
      >
        Cancelar
      </button>
    </div>
  </form>

  <!-- Sección Sistemas y Límites -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
    <!-- Sistemas Activos -->
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-lg font-bold text-slate-900 mb-4">Sistemas Activos</h3>
      <div class="flex flex-wrap gap-2">
        @for (sistema of empresa()!.sistemas_activos; track $index) {
          <span
            class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800"
          >
            {{ sistema }}
          </span>
        }
      </div>
    </div>

    <!-- Límites de Operación -->
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-lg font-bold text-slate-900 mb-4">Límites de Operación</h3>
      <div class="space-y-3">
        <div class="flex justify-between items-center py-2 border-b border-slate-200">
          <span class="text-slate-600">Máximo de Comandas</span>
          <span class="font-semibold text-slate-900">{{ empresa()!.maximo_comandas }}</span>
        </div>
        <div class="flex justify-between items-center py-2 border-b border-slate-200">
          <span class="text-slate-600">Máximo Gestión Tiempos</span>
          <span class="font-semibold text-slate-900">{{ empresa()!.maximo_gestion_tiempos }}</span>
        </div>
        <div class="flex justify-between items-center py-2">
          <span class="text-slate-600">Máximo Sucursales</span>
          <span class="font-semibold text-slate-900">{{ empresa()!.maximo_sucursales }}</span>
        </div>
        <div class="flex justify-between items-center py-2">
          <span class="text-slate-600">Máximo Teléfonos</span>
          <span class="font-semibold text-slate-900">{{ empresa()!.maximo_telefonos }}</span>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <app-progress-spinner
        strokeWidth="8"
        size="48"
      />
      <p class="text-slate-600 mt-4">Cargando datos de la empresa...</p>
    </div>
  </div>
}
